import { FC, ReactNode } from "react";
import imagePng from "images/tribyou_decorations/hero-right2.png";
import HeroSearchForm from "components/HeroSearchForm/HeroSearchForm";
import { StockNumericType } from "data/enums";
import { useTranslation } from "react-i18next";

export interface SectionHeroArchivePageProps {
  className?: string;
  listingType?: ReactNode;
  rightImage?: string;
  defaultType: StockNumericType;
  handleSearch: () => void;
}

const SectionHeroArchivePage: FC<SectionHeroArchivePageProps> = ({
  className = "",
  handleSearch,
  defaultType,
  rightImage = imagePng,
}) => {

  const { t, ready} = useTranslation("translation");

  if (!ready) {
    return null; // or a loading spinner
  }

  const titleGenerator = () => {
    switch (defaultType) {
      case StockNumericType.STAY:
        return t("translation:search.pages.destinations.title") as string;
      case StockNumericType.EXPERIENCE:
        return t("translation:search.pages.experiences.title") as string;
      case StockNumericType.HOLIDAY_PACKAGE:
        return t("translation:search.pages.holidayPackages.title") as string;
      default:
        return t("translation:search.pages.fallback.title") as string;
    }
  };



  return (
    <div
      className={`nc-SectionHeroArchivePage flex flex-col relative ${className}`}
      data-nc-id="SectionHeroArchivePage"
    >
      <div className="flex flex-col lg:flex-row lg:items-center">
        <div className="flex-shrink-0 lg:w-1/2 flex flex-col items-start space-y-6 lg:space-y-10 pb-14 lg:pb-64 xl:pb-80 xl:pr-14 lg:mr-10 xl:mr-0">
          <h2 className="font-medium text-4xl md:text-5xl xl:text-7xl leading-[110%]">
          {titleGenerator()}
          </h2>
        </div>
        <div className="flex-grow">
          <img className="w-full" src={rightImage} alt="hero" />
        </div>
      </div>

      <div className="hidden lg:flow-root w-full">
        <div className="z-10 lg:-mt-40 xl:-mt-56 w-full">
          <HeroSearchForm
            handleSearch={handleSearch}
            defaultType={defaultType}
            moodType={undefined}
          />
        </div>
      </div>
    </div>
  );
};

export default SectionHeroArchivePage;
